export const getUrlWithMedium = (link, value) => {
    const MEDIUM_PARAM_NAME = "m";
    try {
        const url = new URL(link);
        value && url.searchParams.set(MEDIUM_PARAM_NAME, value);
        return decodeURIComponent(url.toString());
    }
    catch (_a) {
        return link;
    }
};
export const navigateTo = (url, bWindow) => {
    bWindow.location.href = url;
};
